export function getUrlCDN(path: any): string {
  return path && path.length > 0
    ? encodeURI(`${process.env.NEXT_PUBLIC_CDN}/${path}`)
    : encodeURI(`${process.env.NEXT_PUBLIC_URL}/icons/icon-512x512.png`);
}
